export default {"src":"/_next/static/media/recipe.41b24f78.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};